{
  "fastAnalysisImageCredits": 1,
  "standardImageCredits": 2,
  "deepAnalysisImageCredits": 4,
  "intellectualPropertyVerificationCredits": 1,
  "gettyIstockEnrichmentCredits": 1,
  "videoCreditWindowSeconds": 5,
  "maxVideoDurationSeconds": 120
}
